import { useContext } from 'react';
import { PreferencesContext } from './PreferencesContext';
/**
 * A hook to retrieve the PreferencesContext which gives access to preferences related configuration.
 * @returns {PreferencesContextValue} The PreferencesContext value
 */
export var usePreferencesContext = function () { return useContext(PreferencesContext); };
